export enum NavBarElement {
    Home = "home",
    Customers = "customers",
    Experts = "experts",
    Chat = "chat",
    Appointements = "appointments",
    Material = "material",
    Account = "account",
    Analytics = "analytics",
    AdminFeatures = "admin-features",
}